import { render, staticRenderFns } from "./Exchange.vue?vue&type=template&id=1028cf20&scoped=true&"
import script from "./Exchange.vue?vue&type=script&lang=js&"
export * from "./Exchange.vue?vue&type=script&lang=js&"
import style0 from "./Exchange.vue?vue&type=style&index=0&id=1028cf20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1028cf20",
  null
  
)

export default component.exports